import React from 'react';
import './CompanyStrategy.css';

function CompanyStrategy() {
  return (
    <div className="document-section">
      <h2>Company Strategy 2025-2029</h2>
      <iframe
        src="/pdfs/company-strategy.pdf"
        title="Company Strategy Document"
        width="100%"
        height="800px"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
}

export default CompanyStrategy;
